require('./profile-button/profile-button.scss');
var BaseViews = require('../base');

var ProfileButton = BaseViews.ItemView.extend({
    _expandedMap: false,
    template: require('./profile-button/profile-button.html'),
    className: 'fmcy-profile-button',
    ui: {
       notificationCount: '.fmcy-profile-notification-count'
    },
    events: {
      'click': 'onClick'
    },
    initialize: function (options) {
        var self = this;
        this.options = _.defaults(
            options || {},
            {
                _appChannel: null,
                _menuState: null,
                open: true,
                notificationCount: 0
            }
        );
    },
    onClick: function () {
      this.options._appChannel.trigger('menu:sidebar:view');
    },
    toggleIcon: function (open) {
      var closeIconClassName = 'fmcy-menu-toggle-close-icon';
      var openIconClassName = 'fmcy-menu-toggle-profile-icon';
      if (!open) {
        this.$el.removeClass(closeIconClassName);
        this.$el.addClass(openIconClassName);
      } else {
        this.$el.removeClass(openIconClassName);
        this.$el.addClass(closeIconClassName);
      }
    },
    _updateNotieCount: function (count) {
      if (count === 0) {
        this.ui.notificationCount.hide();
      } else {
        this.ui.notificationCount.show();
      }
      this.ui.notificationCount.html(count);
    },
    onRender: function () {
      var self = this;
      this._updateNotieCount(this.options.notificationCount);

      this.toggleIcon(false);
      this.listenTo(this.options._appChannel, 'orders:updated', function () {
          self._updateNotieCount( self.options._appChannel.request('orders:ready:count'));
      });
    }
});
module.exports = ProfileButton;



/** WEBPACK FOOTER **
 ** ./assets/js/common/header-control-bar/profile-button.js
 **/